import axios from '../api/index'
export const getDeterminantes = async () =>{
    const fetchDeterminantes = await axios.request('get','/determinantes')
    return fetchDeterminantes.data
}